/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Drastic_Tech_Process_Closed_LogInputs */

const en_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC close]: Process closed with code ${i?.code}`)
};

const fr_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC fermeture] : Processus ferme avec le code ${i?.code}`)
};

const de_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRAMATIVER Abbruch]: Prozess mit Code ${i?.code} beendet`)
};

const it_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Chiusura DRASTICA]: Processo chiuso con codice ${i?.code}`)
};

const ru_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[КРАТКОВРЕМЕННОЕ закрытие]: Процесс завершен с кодом ${i?.code}`)
};

const es_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Cierre DRÁSTICO]: Proceso cerrado con código ${i?.code}`)
};

const zh_cn2_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[紧急关闭]：进程已关闭，关闭代码为${i?.code}`)
};

const ja_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC 終了]: プロセスはコード ${i?.code} で終了しました`)
};

const hi_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[अचानक बंद]: प्रक्रिया कोड ${i?.code} के साथ बंद हो गई`)
};

const pt_pt2_drastic_tech_process_closed_log = /** @type {(inputs: Drastic_Tech_Process_Closed_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Fechamento drástico]: Processo encerrado com o código ${i?.code}`)
};

/**
* | output |
* | --- |
* | "[DRASTIC close]: Process closed with code {code}" |
*
* @param {Drastic_Tech_Process_Closed_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_process_closed_log = /** @type {((inputs: Drastic_Tech_Process_Closed_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Process_Closed_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_process_closed_log(inputs)
	if (locale === "de") return de_drastic_tech_process_closed_log(inputs)
	if (locale === "it") return it_drastic_tech_process_closed_log(inputs)
	if (locale === "ru") return ru_drastic_tech_process_closed_log(inputs)
	if (locale === "es") return es_drastic_tech_process_closed_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_process_closed_log(inputs)
	if (locale === "ja") return ja_drastic_tech_process_closed_log(inputs)
	if (locale === "hi") return hi_drastic_tech_process_closed_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_process_closed_log(inputs)
	return en_drastic_tech_process_closed_log(inputs)
});